const expandScientificNotation = (input: string) => {
  const match = input.match(/^(-?)(\d+)(?:\.(\d*))?[eE]([+-]?\d+)$/)
  if (!match) {
    return input
  }

  const [, sign, integerPart, fractionPart = '', exponentValue] = match
  const digits = `${integerPart}${fractionPart}`
  const decimalIndex = integerPart.length + Number(exponentValue)

  if (decimalIndex <= 0) {
    return `${sign}0.${'0'.repeat(Math.abs(decimalIndex))}${digits}`
  }

  if (decimalIndex >= digits.length) {
    return `${sign}${digits}${'0'.repeat(decimalIndex - digits.length)}`
  }

  return `${sign}${digits.slice(0, decimalIndex)}.${digits.slice(decimalIndex)}`
}

const formatInvoiceAmount = (value?: string | number | null) => {
  const input = expandScientificNotation((value ?? '').toString().trim())
  if (!input) {
    return '0'
  }

  const normalized = input.replace(/,/g, '')
  if (!/^-?\d+(\.\d+)?$/.test(normalized)) {
    return input
  }

  const sign = normalized.startsWith('-') ? '-' : ''
  let [intPart, frac = ''] = normalized.replace(/^-/, '').split('.')
  frac = frac.replace(/0+$/, '')
  intPart = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',')

  return sign + intPart + (frac ? `.${frac}` : '')
}

const formatInvoiceCount = (value?: string | number | null) => {
  const input = Number(value ?? 0)
  if (!Number.isFinite(input)) {
    return '0'
  }

  return input.toLocaleString('en-US')
}

export {formatInvoiceAmount, formatInvoiceCount}
